import { LocationData } from './locationData';
import { CreditScoreTypes } from 'src/app/models/ApplicantDataResponses/credit';

export class SearchPackage
{
    id : number;
    name : string;
    reusable : boolean;
    clientLocationId : number;
    isDefaultPackage : boolean;
    isPassFailPackage: boolean;
    isPMPackage : boolean;
    searches : Array<SearchRecord>;
    cost:number;
    clientId :any;
    notes: string;
    selected : boolean;
    isActive : boolean;
    createdOn : Date;
    lastModified : Date;
    lastModifiedBy : string;
    clientIds :number[];
    stpOnly : boolean;
    isTieredPackage : boolean;
    searchesString : string;
    public get SearchPackageString() : string {
        let s = '';
        this.searches.forEach(srch => {
            if (s.length === 0) {
                s += srch.name;
            } else {
                s += ',' + srch.name;
            }
        });
        return s;
    }
    
    compareSearchMeta(a, b) {
        for(var key in a) {
            if(!(key in b) || a[key] !== b[key]) {
                return false;
            }
        }
        for(var key in b) {
            if(!(key in a) || a[key] !== b[key]) {
                return false;
            }
        }
        return true;
    }

    searchInPackage(srch: SearchRecord): boolean{
        let existing = this.searches.find(sr=>{return sr.searchType == srch.searchType && sr.vendor == srch.vendor && srch.name == sr.name && this.compareSearchMeta(srch.searchMeta,sr.searchMeta) && sr.isTieredSearch == srch.isTieredSearch});
        if(existing){
            // // if its a county search or a state search we need to check the county/state
            // if(existing.name.includes('State')|| existing.name.includes('County')){
            //     if(existing.name.includes('County')) return (existing.searchMeta.state == srch.searchMeta.state && existing.searchMeta.county == srch.searchMeta.county);
            //     return existing.searchMeta.state == srch.searchMeta.state;
            // }
           return true;
        }else
            return false;
    }

    get containsVerifications() : boolean{
        if(this.searchesString)
            return (this.searchesString.indexOf('Employment') > -1 || this.searchesString.indexOf('Residence') > -1);
        else
            return (this.SearchPackageString.indexOf('Employment') > -1 || this.SearchPackageString.indexOf('Residence') > -1);
        //return this.searches.filter(sr => {return sr.searchType == VendorResponseTypes.ResidenceVerification || sr.searchType == VendorResponseTypes.Employment}).length > 0;
    }

    
    public get hasEmpVer() : boolean {
        return this.SearchPackageString.indexOf('Employment') > -1 
    }
    
    public get hasResVer() : boolean {
        return this.SearchPackageString.indexOf('Residence') > -1 
    }

}

export class SearchRecord
{
    id : number;
    name : string;
    vendor : SearchVendors;
    cost : number;
    vendorName : string;
    searchType : VendorResponseTypes;
    searchMeta : any;
    includedInBundledPrice : boolean;
    searchesIncludedInBundledPrice : number;
    orderId : number;
    processingNotes : string;
    isTieredSearch: boolean;
    searchdataLocation : LocationData;
    
    public get canShowInSearchFilter() : boolean {
        return this.searchMeta && this.searchMeta.isManuallyTriggered;
    }
    
    
    public get showVendorDropdown() : boolean {
        return  (this.searchType == 2 && (this.searchMeta.searchDepth == 0  || this.searchMeta.searchDepth == 5 || this.searchMeta.searchDepth == 4 )) || this.searchType == 3 || this.searchType == 12 || this.searchType === 14;
    }
    

    // Properties used in client search package pricing.
    searchPackageId : number;
    clientId : number;
    restrictedForClientId : number[] = [];

    public get isManualTrigger() : boolean {
        try {
            let val = JSON.parse(this.searchMeta["isManuallyTriggered"]) || false;
            return val
        } catch (error) {
            return false;
        }
    }
    public set isManualTrigger(value : boolean) {
        this.searchMeta["isManuallyTriggered"] = value;
    }

    
    public get includeFICO() : boolean {
     try {
        let val = JSON.parse(this.searchMeta["score"]) || false;
        return val
     } catch (error) {
         return false;
     }
    }

    public set includeFICO(value : boolean) {
        this.searchMeta["score"]= value;
    }
    
    public get creditScoreType() : CreditScoreTypes{
        return this.searchMeta['creditScoreType'] as CreditScoreTypes;
    }

    public set creditScoreType(value : CreditScoreTypes) {
        this.searchMeta["creditScoreType"]= value;
    }
    
}

export class CustomResponseData {
    id : number;
    searchName : string;
    customSearchDescription : string;
    includeWithReport : boolean;
    recordFound : boolean;
    customSearchStatus : SearchStatus;
    searchStatusDisplay : string;
    orderId : number;
    applicantId : number;
    receivedDate : Date;
    responseType : VendorResponseTypes;
    inviteToken : string;
    searchQualifier : string;
    editing : boolean;
    isImage : boolean;
    searchEntryId: number;
}

export enum SearchStatus {
    NotRun = 1, //- in the package, but wasn’t ever pulled from vendor
    Processing = 2, //- waiting to receive information back from the vendor
    Complete = 3,  //- search is done
    Error = 4, //- received an error from the vendor
    Voided = 5, // - search was canceled by a CRA user
    InDispute = 6 // - applicant has called in to dispute an item in the search. Status can only be initiated manually by a CRA user
}

export enum CriminalSearchTypes
{
    County = 0,
    State = 1,
    Federal = 2,
    // international = 3,
    SingleState = 4,
    National = 5,
    NationalAlias = 6,
    // security = 7
    UtahJusticeCourtScrape = 8,
    UtahDistrictCourtScrape = 9,
    Ofac = 10
}

export enum VendorResponseTypes
{
    Credit = 1,
    Criminal = 2,
    Eviction = 3,
    Person = 4,
    Employment = 5,
    FollowUp = 6,
    TaxLien = 7,
    RentToIncome = 8,
    //this is set to 9 because RentToIncome is mapped to 8 on the backend
    CustomSearch = 9,
    Error = 10,
    ResidenceVerification = 11,
    IdentityVerification = 12,
    IncomeVerification = 13,
    EvictionVerification = 14
}

export enum SearchVendors
{
    TazWorks = 0,
    Tracers = 1,
    Custom = 2,
    UtahCourts = 3,
    SJV = 4,
    Cleara = 5,
    Wholesale = 6,
    MasterCard = 7,
    Equifax = 8,
    RIQFIN = 9, //NOTE: Equifax is now enum value 8, not sure if it has any FE components yet tho
    Prove = 10,
    Transunion = 11,
    Astute = 12
}

export class VendorSelectValues {
    vendorId : number;
    vendorName : string;
}

export class SearchFee { 
    searchId: number;
    amount: number;
    feeType: string;

}

export class SearchFeeLookupPayload {
    county: string;
    state: string;
    searches: SearchRecord[];
}

//Matches API VendorIdentifierLookupResponse (RIQ-5210). 
export interface VendorIdentifierLookupResponse {
    vendorIdentifier: string;
    orderHistoryId: number;
    orderDateUtc: string;
    searchVendor: string;
    searchType: string;
}

